import "@/css/AboutUs/strength.css";
import { get } from "@/js/request.js";
document.getElementById("loading").classList.remove("active");
//静态数据
let dataList = {
  brandItemData: [
    {
      imageUrl: require("@/assets/image/brand-bg.png"),
    },
    {
      imageUrl: require("@/assets/image/brand-bg.png"),
    },
    {
      imageUrl: require("@/assets/image/brand-bg.png"),
    },
    {
      imageUrl: require("@/assets/image/brand-bg.png"),
    },
    {
      imageUrl: require("@/assets/image/brand-bg.png"),
    },
  ],
};
//5大品牌
let brandItemData = dataList.brandItemData;
let brandItem = Array.from(document.querySelectorAll(".brand-box img"));
brandItem.forEach(
  (item, idx) =>
    (item.src = require("@/assets/image/brand" + (idx + 1) + ".png"))
);
document.querySelectorAll(
  ".app img"
)[0].src = require("@/assets/image/wechatPhone.png");
//实验室
let laboratoryBox = Array.from(
  document.querySelectorAll(".laboratory-box img")
);
laboratoryBox[0].src = require("@/assets/image/strength_1.png");
//团队
let teamBox = Array.from(document.querySelectorAll(".team-box img"));
teamBox[0].src = require("@/assets/image/strength_3.jpg");
// 创新药研发应用
var swiper = new Swiper(".swiper-container", {
  pagination: ".swiper-pagination",
  paginationClickable: true,
  nextButton: ".swiper-button-next",
  prevButton: ".swiper-button-prev",
  spaceBetween: 30,
  effect: "fade",
  autoplay: 3000,
  loop: false,
});

let swiperImg = Array.from(document.querySelectorAll(".swiper-wrapper img"));
swiperImg.forEach(
  (item, idx) =>
    (item.src = require("@/assets/image/strength_" + (4 + idx) + ".jpg"))
);
// 艾草示范
let aytsao = Array.from(document.querySelectorAll(".ay-tsao img"));
aytsao.forEach(
  (item, idx) =>
    (item.src = require("@/assets/image/aytsao" + (idx + 1) + ".jpg"))
);
// 艾草的标准化与规模化
let timeLineItem = Array.from(
  document.querySelectorAll(".timeline .swiper-container .swiper-slide")
);
timeLineItem.forEach((item, idx) => {
  item.style.backgroundImage =
    "url(" + require("@/assets/image/progress-big" + (idx + 1) + ".jpg") + ")";
});
var timelineSwiper = new Swiper(".timeline .swiper-container", {
  direction: "vertical",
  loop: false,
  speed: 1600,
  autoplay: 3000,
  mousewheelControl: true,
  pagination: ".swiper-paginations",
  effect: "slide",
  paginationBulletRender: function (swiper, index, className) {
    var year = document
      .querySelectorAll(".timeline .swiper-container .swiper-slide")
      [index].getAttribute("data-year");
    return '<span class="' + className + '">' + year + "</span>";
  },
  paginationClickable: true,
  nextButton: ".swiper-button-nexts",
  prevButton: ".swiper-button-prevs",
  breakpoints: {
    768: {
      direction: "horizontal",
    },
  },
});
